<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>{{ customer.company }} - Questionnaire </h1>
                <div class="pageOptions" v-if="!runPrint">
                    <btn text="Imprimer" ico="print" @click="print"></btn>
                    <btn ico="times" color="red" @click="cancel"></btn>
                </div>
            </div>
        </div>
        <div class="double" ref="responseTop">
            <form class="responses" ref="responses" autocomplete="off" @submit.prevent="() => {return false}">
                <Question v-for="(question,k) in questions"
                          :key="k"
                          :k="k"
                          :question="question"
                          :response="responses[k]"
                          :locked="false"
                          v-if="question.show && isLoaded"
                          @textfocus="blockAnim = true"
                          @textblur="blockAnim = false"
                          :newClass="newQuestions[k] > 0"
                          :is-print="isPrint"
                />
            </form>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import tools from '../config.ts';
import Btn from "@/components/Btn";
import Loader from "@/components/Loader";
import Question from "@/components/response/Question";

export default {
    name: "ResponsePrint",
    components: {Question, Loader, Btn},
    data() {
        return {
            questionnaireId: 0,
            customerId: 0,
            responseId: 0,
            
            isLoaded: false,
            questionnaire: {reason: {}},
            conditionVisible: {},
            questions: {},
            responses: [],
            customer: {},
            preview: false,
            
            blockAnim: false,
            newQuestion: 0,
            newQuestions: [],
            
            isPrint: false,
            runPrint:false,
            
            tree:[],
        }
    },
    methods: {
        
        load() {
            
            axios.get(tools.api("questionnaire/" + this.questionnaireId), tools.headerGET())
                .then((response) => {
                    this.questionnaire = response.data;
                    this.questions = JSON.parse(this.questionnaire.questions);
                    
                    tools.loader(false);
                    this.questions.forEach((question) => {
                        let values = [];
                        question.content.forEach((content) => {
                            values.push("");
                        });
                        this.responses.push({
                            question: question.id,
                            value: values,
                        });
                        this.newQuestions.push(0);
                    });
                    
                    this.customerId = this.questionnaire.customer_id;
                    
                    this.loadCustomer();
                    this.loadTree();
                    this.updateConditions();
                    // on double dans un cas particlier
                    this.updateConditions();
                    // console.log(this.conditionVisible);
                    
                    this.isLoaded = true;
                    
                })
                .catch((e) => {
                    console.log(e)
                    tools.loader(false);
                })
        },
        loadCustomer() {
            axios.get(tools.api("customer/" + this.customerId), tools.headerGET())
                .then((response) => {
                    this.customer = response.data;
                })
        },
        cancel() {
            this.$router.back();
        },
        condition(question, questionKey) {
            
            // si la question n'a pas de condition on l'affiche
            if (question.conditions.length <= 0) {
                return true;
            }
            // on recrée le pattern
            let pattern = question.pattern
            if (!pattern) {
                pattern = "";
                question.conditions.forEach((condition, key) => {
                    pattern += "condition_" + (key + 1) + " ET "
                });
                pattern = pattern.substr(0, pattern.length - 4);
            }
            
            let show = false;
            // on lit le pattern condition par condition
            let Ors = pattern.split("OU");
            
            Ors.forEach((Or, k) => {
                
                if (show) return;
                
                let Ands = Or.split("ET")
                let nbAnd = 0;
                let total = 0;
                Ands.forEach((And, i) => {
                    
                    let condition = parseInt(And.replace(/[condit_(]+(\d)\)?/, "$1").trim());
                    
                    if (!question.conditions[condition - 1] || !this.conditionVisible[question.id]) {
                        // console.log("erreur questionKey "+questionKey+"[id:"+question.id+"] => ")
                        return;
                    }
                    
                    if (this.conditionVisible[question.id]["condition_" + (condition - 1)].valide) {
                        total++;
                    }
                    
                    nbAnd++;
                    
                })
                
                if (total === nbAnd && total > 0) {
                    // console.log("questionKey "+questionKey+"[id:"+question.id+"] => total:"+total+"; nbAdd:"+nbAnd+"; show:"+(total === nbAnd && total > 0))
                    show = true;
                }
            });
            
            if (show && !question.show) {
                
                // console.log({question})
                // console.log({pattern})
                // console.log(this.questionConditionValide[question.id])
                //
                //
                // on pré-rempli les réponses pour que ca ne crée pas d'erreur dans la calcul des conditions
                let values = [];
                
                question.content.forEach(() => {
                    values.push("");
                });
                
                this.responses[questionKey].value = values;
                
                // on joue 2 animations pour notifié de la nouvelle question
                this.newQuestions[questionKey] = setTimeout(() => {
                    this.newQuestions[questionKey] = 0
                }, 3000)
                
                clearTimeout(this.newQuestion)
                
                this.newQuestion = setTimeout(() => {
                    this.newQuestion = 0
                }, 3000)
                
            }
            
            if (!show && question.show) {
                let values = [];
                
                question.content.forEach(() => {
                    values.push("");
                });
                
                this.responses[questionKey].value = values;
            }
            
            return show;
        },
        
        showResponses(question, k) {
            let response = this.getResponseByQuestionId(question.id);
            
            let res = "";
            response.value.forEach((val) => {
                if (val !== "") {
                    res += val + ", ";
                }
            });
            
            res = res.substr(0, res.length - 2);
            return res;
        },
        showQuestionText(question) {
            if (question.labelText) {
                return question.labelText;
            }
            return question.label
        },
        getQuestionById(questionId) {
            return this.questions.find((question) => question.id === questionId)
        },
        getResponseByQuestionId(questionId) {
            return this.responses.find((response) => response.question === questionId)
        },
        isCheckbox(question) {
            return question.type === 'checkbox' || question.type === 'radio' || question.type === 'select';
        },
        
        questionIsValide(condition) {
            
            let question = this.getQuestionById(condition.question);
            let response = this.getResponseByQuestionId(condition.question);
            
            if (!question) return false;
            
            if (!question.show && question.conditions.length === 0) {
                question.show = true;
            }
            
            // si il n'y a pas de réponse ou si la question n'est pas affiché
            if (!response || !question.show) return false;
            
            let value = condition.responses.value;
            if (!value) value = "";
            value = value.replace(/\(/g, "\\(")
                .replace(/\)/g, "\\)")
                .replace(/\[/g, "\\[")
                .replace(/\]/g, "\\]")
                .replace(/\-/g, "\\-")
                .replace(/\+/g, "\\+")
                .replace(/\*/g, "\\*")
                .replace(/\//g, "\\/")
                .replace(/\</g, "\\<")
            
            let regex = new RegExp(value);
            let equal = condition.responses.equal;
            let responsesValide = false;
            
            if (equal === "not-equal" || equal === "not-contain") {
                responsesValide = true;
            }
            
            // cas particulier pour les différent de vide
            if (equal === "not-equal" && condition.responses.value === "") {
                responsesValide = true;
                let vide = 0
                response.value.forEach((value) => {
                    if (value == "") {
                        vide++;
                    }
                })
                if (vide === response.value.length) {
                    responsesValide = false;
                }
                return responsesValide;
            }
            
            response.value.forEach((value) => {
                
                switch (equal) {
                    case "equal":
                        if (value == condition.responses.value) {
                            responsesValide = true;
                        }
                        break;
                    case "contain":
                        if (value.match(regex)) {
                            responsesValide = true;
                        }
                        break;
                    case "not-equal":
                        // if (condition.question == 5) {
                        //     console.log("value : " + value)
                        //     console.log("condition.responses.value) : " + condition.responses.value)
                        // }
                        
                        if (value == condition.responses.value) {
                            responsesValide = false;
                        }
                        break;
                    case "not-contain":
                        if (value.match(regex)) {
                            responsesValide = false;
                        }
                        break;
                }
            })
            
            return responsesValide;
        },
        loadTree(){
            // on récupère les question de 1er niveau
            this.questions.forEach(question => {
                if(question.conditions.length <= 0){
                    this.tree.push({
                        ...question,child:this.treeGetChild(question),
                    });
                }
            })
        
            console.log(this.tree);
        },
        treeGetChild(q){
            let child = []
            for(let i = 0; i < this.questions.length; i++){
                let question = this.questions[i];
                for(let k = 0; k < question.conditions.length; k++){
                    let condition = question.conditions[k];
                    if(condition.question === q.id){
                        child.push({...question,child: this.treeGetChild(question)});
                    }
                }
            }
            return child;
        },
        updateConditions() {
            let conditions = {};
            let conditionsSave = {};
            let needReupdate = false;
            
            this.questions.forEach((question, questionKey) => {
                question.conditions.forEach((condition, k) => {
                    if (!conditions[question.id]) {
                        conditions[question.id] = {};
                    } else if (conditions[question.id]["condition_" + k]) {
                        question.id = question.id + "_" + questionKey;
                        conditions[question.id] = {};
                    }
                    // console.log(condition.question+"|"+condition.responses.equal+"|"+condition.responses.value)
                    let value = condition.responses.value;
                    if (!value) value = "";
                    
                    let key = condition.question + "|" + condition.responses.equal + "|" + value.trim()
                    if (!conditionsSave[key]) {
                        conditionsSave[key] = this.questionIsValide(condition)
                    }
                    
                    if (this.isPrint) {
                        conditionsSave[key] = true;
                    }
                    
                    conditions[question.id]["condition_" + k] = {
                        questionId: condition.question,
                        questionKey: questionKey,
                        equal: condition.responses.equal,
                        value: condition.responses.value,
                        valide: conditionsSave[key]
                    };
                    
                    // on check si la condition à changé d'état
                    if (this.conditionVisible[question.id] && this.conditionVisible[question.id]["condition_" + k].valide !== conditions[question.id]["condition_" + k].valide) {
                        needReupdate = true;
                    }
                    
                    // console.log(question.id,conditions[question.id]["condition_" + k])
                })
                
                question.show = this.condition(question, questionKey);
            })
            
            // console.log(conditions)
            // console.log(conditionsSave)
            this.conditionVisible = conditions;
            
            if (needReupdate) {
                // console.log("need update")
                return this.updateConditions();
            }
        },
        print() {
            this.runPrint = true;
            document.body.classList.add("print")
            setTimeout(() => {
                
                window.print();
                this.runPrint = false;
                document.body.classList.remove("print")
            },500)
        }
        
    },
    computed: {
    
    },
    watch: {
    
    },
    mounted() {
        
        if (!this.$store.getters.hasPerm('questionnaire:print')) {
            return this.$router.back();
        }
        
        this.questionnaireId = this.$route.params.questionnaire_id;
        
        this.isPrint = true;
        this.responseId = 0;
        this.preview = true;
        
        this.$store.commit("onEditMode", true);
        
        tools.loader(true);
        
        this.load();
        
    }
}
</script>